import { Tables } from "@/integrations/supabase/types";
import { AddCardToBinderBindersInputItem } from "../AddCardToBinderBindersInputItem/AddCardToBinderBindersInputItem";
import { useEffect, useRef } from "react";

interface Props {
  options: Array<Tables<"binders"> & { card_count: string; total_sum: string }>;
  value: Tables<"binders">["id"] | null;
  onChange: (binder: Tables<"binders">["id"]) => void;
  disabled: boolean;
}

export function AddCardToBinderBindersInput({
  options,
  value,
  onChange,
  disabled,
}: Props) {
  const activeElementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      if (activeElementRef.current) {
        activeElementRef.current.scrollIntoView();
      }
    }, 0);
  }, []);

  return (
    <div className="flex items-center gap-2 overflow-x-auto">
      {options.map((binder) => (
        <div
          key={binder.id}
          ref={(el) => {
            if (el && value === binder.id) {
              activeElementRef.current = el;
            }
          }}
        >
          <AddCardToBinderBindersInputItem
            binder={binder}
            active={value === binder.id}
            onClick={() => onChange(binder.id)}
            disabled={disabled}
          />
        </div>
      ))}
    </div>
  );
}
